import React from "react";

const VoterAvatars = ({ voters, maxDisplay = 5 }) => {
  const displayedVoters = voters.slice(0, maxDisplay);
  const remainingCount = voters.length - maxDisplay;

  return (
    <div className="tw-flex tw-items-center">
      <div className="tw-flex -tw-space-x-2">
        {displayedVoters.map((voter, index) => (
          <div
            key={index}
            className="tw-w-8 tw-h-8 tw-rounded-full tw-border-2 tw-border-white tw-overflow-hidden tw-relative tw-group"
          >
            <img
              src={voter.avatar_url}
              alt={voter.first_name}
              className="tw-w-full tw-h-full tw-object-cover"
            />
            <div className="tw-absolute tw-invisible tw-group-hover:tw-visible tw-bg-black tw-text-white tw-px-2 tw-py-1 tw-rounded tw-text-xs tw-whitespace-nowrap tw-bottom-full tw-left-1/2 tw-transform -tw-translate-x-1/2 -tw-translate-y-2">
              {voter.first_name}
            </div>
          </div>
        ))}
        {remainingCount > 0 && (
          <div className="tw-w-8 tw-h-8 tw-rounded-full tw-bg-gray-100 tw-border-2 tw-border-white tw-flex tw-items-center tw-justify-center">
            <span className="tw-text-xs tw-font-medium tw-text-gray-600">
              +{remainingCount}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default VoterAvatars;
